module.exports = __webpack_public_path__ + "static/media/ico-delete-mycontent.bbf1987d.svg";